import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-vehicle-gate-pass',
  templateUrl: './vehicle-gate-pass.component.html',
  styleUrls: ['./vehicle-gate-pass.component.scss']
})
export class VehicleGatePassComponent implements OnInit {
  title: any;
  from_date: any;
  to_date: any;
  data_loading = false;
  is_data_available = false;
  document_file: any;
  sale_data = [];
  vehicle_register_form: FormGroup;
  from_date_after_search: any;
  to_date_after_search: any;
  is_gate_pass_prepared = false;
  enable_old_gatepass_page = false;
  old_gate_pass_list: any = [];

  constructor(private globalService: GlobalService, private httpService: HttpService, private formBuilder: FormBuilder) {
    this.title = this.globalService._active_display_name;
    this.vehicle_register_form = this.formBuilder.group({
      driver_name: [null, Validators.compose([Validators.required])],
      vehicle_number: [null, Validators.compose([Validators.required])],
      vehicle_start_time: [null, Validators.compose([Validators.required])],
    });
  }

  enableMainAndSubPage() {
    this.enable_old_gatepass_page = !this.enable_old_gatepass_page;
  }

  serveOldGatePassAndOrder() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    };
    this.data_loading = true;
    this.is_data_available = false;
    this.is_gate_pass_prepared = false;
    this.old_gate_pass_list = [];
    this.httpService.serveVehicleGatepassAndOrder(data_dict).subscribe((data: any) => {
      console.log(data);
      this.data_loading = false;
      this.old_gate_pass_list = data['old_gate_pass_list'];
      if (this.old_gate_pass_list.length !== 0) {
        this.is_data_available = true;
      }
      this.sale_data = data['sale_data'];
      if (this.sale_data.length == 0) {
        alert('No Bill Available for this date');
        return false;
      }
      this.from_date_after_search = this.from_date;
      this.to_date_after_search = this.to_date;
    }, (error) => {
      this.data_loading = false;
      console.error(error);
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  downloadOldGatepassClicked(pdf_string, vehicle_number, driver_name) {
    const linkSource = 'data:application/pdf;base64,' + pdf_string;
    const downloadLink = document.createElement("a");
    const fileName = vehicle_number + '-' + driver_name + '.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  checkDisabled() {
    let filter_value: any = [] = this.sale_data.filter((sale) => {
      return sale.is_selected;
    })
    if (filter_value.length > 0 && this.vehicle_register_form.valid) {
      return false;
    } else {
      return true;
    }
  }

  getDateFromHours(time) {
    time = time.split(':');
    let now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...time);
  }

  generateClicked() {
    let time = this.vehicle_register_form.value.vehicle_start_time
    if (new Date() > this.getDateFromHours(time)) {
      alert('You cannot enter old Time');
      return false;
    }
    let filter_value: any = [] = this.sale_data.filter((sale) => {
      return sale.is_selected;
    })
    if (filter_value.length == 0) {
      alert('Please Select Order to Generate');
      return false;
    }
    let data_dict = {
      'vehicle_details': this.vehicle_register_form.value,
      'sale_data': filter_value,
      'from_date': this.from_date_after_search,
      'to_date': this.to_date_after_search
    }
    console.log(data_dict);
    this.httpService.prepareVehicleGatePass(data_dict).subscribe((data) => {
      console.log(data);
      this.is_gate_pass_prepared = true;
      this.document_file = data;
      this.clearFormCalled();
    }, (error) => {
      console.error(error);
    });
  }

  clearFormCalled() {
    this.sale_data = [];
    this.is_data_available = false;
    this.vehicle_register_form.reset();
    this.from_date = null;
    this.to_date = null;
  }

  ngOnInit() {
  }

}
